import { useState } from 'react';
import { Box, Typography } from '@mui/material';

import PlotMarkerList from './PlotMarkerList';
import PlotMarkerForm from './PlotMarkerForm';
import type { PlotWaypoint as PlotWaypointType } from '@/types';

interface PlotWaypointProps {
  waypoint: PlotWaypointType;
  plotId: string | undefined;
  plotStatus?: string;
  onMarkersChange: () => void | Promise<void>;
}

function PlotWaypoint({
  waypoint,
  plotId,
  plotStatus,
  onMarkersChange,
}: PlotWaypointProps): React.JSX.Element {
  const [markerFormOpen, setMarkerFormOpen] = useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const handleAddMarker = () => {
    setMarkerFormOpen(true);
  };

  const handleMarkerCreated = () => {
    // Trigger refresh by updating the refresh trigger
    setRefreshTrigger((prev) => prev + 1);
    setMarkerFormOpen(false);
    // Notify parent component that markers have changed
    if (onMarkersChange) {
      onMarkersChange();
    }
  };

  const handleCloseMarkerForm = () => {
    setMarkerFormOpen(false);
  };

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 'bold' }}>
          {waypoint.name}
        </Typography>
        <PlotMarkerList
          plotId={plotId}
          waypointId={waypoint.entity_id}
          plotStatus={plotStatus}
          onAddMarker={handleAddMarker}
          refreshTrigger={refreshTrigger}
          onMarkersChange={onMarkersChange}
        />
      </Box>

      <PlotMarkerForm
        open={markerFormOpen}
        onClose={handleCloseMarkerForm}
        plotId={plotId}
        waypointId={waypoint.entity_id}
        onMarkerCreated={handleMarkerCreated}
      />
    </>
  );
}

export default PlotWaypoint;

